// src/features/locations/PortfolioView.jsx
//
// Thin wrapper — the live /offices route renders OfficesPage (src/v2/locations/).
// All private helpers from the legacy implementation have been removed.
// AppShell imports the named export { PortfolioView } from this file.
import React from "react";
import { OfficesPage } from "../../v2/locations/OfficesPage.jsx";

export function PortfolioView(props) {
  return <OfficesPage {...props} />;
}
